(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Number-Counter"] && !Shopify.designMode) return;
  try {
    
  $(".circle_percent").each(function() {
    var $this = $(this),
		$dataV = $this.data("percent"),
		$dataDeg = $dataV * 3.6,
		$round = $this.find(".round_per");
	$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");	
	$this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
	$this.prop('Counter', 0).animate({Counter: $dataV},
	{
		duration: 2000, 
		easing: 'swing', 
		step: function (now) {
            $this.find(".percent_text").text(Math.ceil(now)+"%");
        }
    });
	if($dataV >= 51){
		$round.css("transform", "rotate(" + 360 + "deg)");
		setTimeout(function(){
			$this.addClass("percent_more");
		},1000);
		setTimeout(function(){
			$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
		},1000);
	} 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enrollment-form"] && !Shopify.designMode) return;
  try {
    
  const ENROLLMENT_APP_PROXY_PATH = '/a/dashboard';
  const ENROLLMENT_REQUEST_TIMEOUT_MS = 20000;
  const ENROLLMENT_SERVICES_URL = 'https://mendlycare.de/pages/how-many-services';

  class EnrollmentForm extends HTMLElement {
    constructor() {
      super();
      this.isLoggedIn = this.dataset.loggedIn === 'true';
      this.customerFirstName = (this.dataset.customerFirstName || '').trim();
      this.customerLastName = (this.dataset.customerLastName || '').trim();
      this.customerEmail = (this.dataset.customerEmail || '').trim();
      this.membersCount = this.resolveMembersCount();
      this.defaultState = this.resolveState();
      this.hasRequiredState = this.isValidState(this.defaultState);
      this.hasCartItems = this.dataset.hasCartItems === 'true';
      this.currentStep = this.resolveInitialStep();
      this.personalDetails = [];
      this.swiperInstance = null;
      this.cartUpdateTimer = null;
      this.pendingPersonalDetailsError = null;
      this.init();
    }

    resolveMembersCount() {
      const param = new URLSearchParams(window.location.search).get('missingDNA');
      const fromUrl = parseInt(param, 10);
      if (Number.isInteger(fromUrl) && fromUrl >= 1 && fromUrl <= 10) {
        return fromUrl;
      }

      const fromData = parseInt(this.dataset.missingDna, 10);
      if (Number.isInteger(fromData) && fromData >= 1 && fromData <= 10) {
        return fromData;
      }

      return 1;
    }

    resolveState() {
      const param = new URLSearchParams(window.location.search).get('state');
      if (param && /^[A-Za-z]{2}$/.test(param.trim())) {
        return param.trim().toUpperCase();
      }

      const fromData = (this.dataset.state || '').trim().toUpperCase();
      if (/^[A-Z]{2}$/.test(fromData)) {
        return fromData;
      }

      return '';
    }

    resolveInitialStep() {
      if (!this.hasRequiredState) return 'state-required';
      if (!this.hasCartItems) return 'cart-required';
      return 1;
    }

    activateStep(step) {
      this.querySelectorAll('.enrollment-step').forEach((stepEl) => {
        stepEl.classList.remove('active');
      });

      const stepEl = this.querySelector(`.enrollment-step-${step}`);
      if (stepEl) {
        stepEl.classList.add('active');
      }

      const stepIndicator = this.querySelector('.enrollment-form__step-indicator');
      if (stepIndicator) {
        if (typeof step === 'number') {
          stepIndicator.classList.remove('hidden');
          const stepIndicatorCurrent = this.querySelector('.step-indicator__current');
          if (stepIndicatorCurrent) {
            stepIndicatorCurrent.textContent = step;
          }
        } else {
          stepIndicator.classList.add('hidden');
        }
      }

      this.currentStep = step;
    }

    init() {
      if (!this.hasRequiredState) {
        this.activateStep('state-required');
        return;
      }

      if (!this.hasCartItems) {
        this.activateStep('cart-required');
        return;
      }

      this.activateStep(1);

      const nextBtns = this.querySelectorAll('.enrollment-form__next-btn');
      const prevBtns = this.querySelectorAll('.enrollment-form__prev-btn');
      const submitBtn = this.querySelector('.enrollment-form__submit-btn');

      nextBtns.forEach((btn) => {
        const target = parseInt(btn.dataset.nextStep, 10);
        if (target) {
          btn.addEventListener('click', () => this.goToStep(target));
        }
      });

      prevBtns.forEach((btn) => {
        const target = parseInt(btn.dataset.prevStep, 10);
        if (target) {
          btn.addEventListener('click', () => this.goToStep(target));
        }
      });

      if (submitBtn) {
        submitBtn.addEventListener('click', () => this.handleSubmit());
      }

      if (this.currentStep === 1) {
        this.initializePersonalDetails();
      }
    }

    showStateRequired() {
      this.activateStep('state-required');
    }

    showCartRequired() {
      this.activateStep('cart-required');
    }

    async goToStep(step) {
      if (!this.hasRequiredState) {
        this.showStateRequired();
        return;
      }

      if (!this.hasCartItems) {
        this.showCartRequired();
        return;
      }

      if (step === 2 && this.currentStep === 1) {
        const firstError = this.validatePersonalDetails();
        if (firstError) {
          this.goToPersonalDetailsSlide(firstError.index, firstError.field);
          return;
        }
      }

      if (step === 3 && this.currentStep === 2) {
        const sequencingError = await this.validateSequencingServicesInCart();
        if (sequencingError) {
          showToast(sequencingError, {
            type: 'error',
            duration: 6000
          });
          return;
        }
      }

      const currentStepEl = this.querySelector(`.enrollment-step-${this.currentStep}`);
      const nextStepEl = this.querySelector(`.enrollment-step-${step}`);

      if (currentStepEl) {
        currentStepEl.classList.remove('active');
      }

      if (nextStepEl) {
        nextStepEl.classList.add('active');
        this.currentStep = step;

        const stepIndicator = this.querySelector('.step-indicator__current');
        if (stepIndicator) {
          stepIndicator.textContent = step;
        }

        if (step === 1) {
          const wrapper = this.querySelector('[id^="personal-details-wrapper"]');
          const hasExistingSlides = Boolean(wrapper?.children.length);

          if (!hasExistingSlides) {
            this.initializePersonalDetails();
          } else {
            this.initializeSwiper(false);
          }

          if (this.pendingPersonalDetailsError) {
            const error = this.pendingPersonalDetailsError;
            this.pendingPersonalDetailsError = null;
            setTimeout(() => this.goToPersonalDetailsSlide(error.index, error.field), 150);
          }
        }

        if (step === 2) {
          this.updatePeopleSummary();
        }

        if (step === 3) {
          this.renderCartSummary();
        }
      }
    }

    getPersonalDetailsSectionId() {
      const wrapper = this.querySelector('[id^="personal-details-wrapper"]');
      return wrapper ? wrapper.id.split('-').pop() : '';
    }

    collectPersonalDetails() {
      const sectionId = this.getPersonalDetailsSectionId();
      const details = [];

      for (let i = 0; i < this.membersCount; i++) {
        if (i === 0 && this.isLoggedIn) {
          const firstNameFromInput = this.querySelector(`#first-name-${sectionId}-${i}`)?.value?.trim() || '';
          const lastNameFromInput = this.querySelector(`#last-name-${sectionId}-${i}`)?.value?.trim() || '';
          details.push({
            first_name: this.customerFirstName || firstNameFromInput,
            last_name: this.customerLastName || lastNameFromInput,
            birthday: this.querySelector(`#birthday-${sectionId}-${i}`)?.value?.trim() || '',
            state: this.defaultState,
            email: this.customerEmail,
            phone: this.querySelector(`#phone-${sectionId}-${i}`)?.value?.trim() || '',
            ...this.collectPersonOptions(sectionId, i)
          });
          continue;
        }

        details.push({
          first_name: this.querySelector(`#first-name-${sectionId}-${i}`)?.value?.trim() || '',
          last_name: this.querySelector(`#last-name-${sectionId}-${i}`)?.value?.trim() || '',
          birthday: this.querySelector(`#birthday-${sectionId}-${i}`)?.value?.trim() || '',
          state: this.defaultState,
          email: this.querySelector(`#email-${sectionId}-${i}`)?.value?.trim() || '',
          phone: this.querySelector(`#phone-${sectionId}-${i}`)?.value?.trim() || '',
          ...this.collectPersonOptions(sectionId, i)
        });
      }

      return details;
    }

    isValidBirthday(birthday) {
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(birthday)) return false;

      const [month, day, year] = birthday.split('/').map(Number);
      const date = new Date(year, month - 1, day);

      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return false;
      }

      const min = new Date(1900, 0, 1);
      const max = new Date();
      return date >= min && date <= max;
    }

    isValidEmail(email) {
      const value = String(email || '').trim();
      if (!value || value.length > 254) return false;

      const atIndex = value.lastIndexOf('@');
      if (atIndex <= 0 || atIndex > 64) return false;

      const local = value.slice(0, atIndex);
      const domain = value.slice(atIndex + 1);
      if (!domain || domain.length > 64) return false;

      if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
      if (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false;
      if (domain.startsWith('-') || domain.endsWith('-')) return false;

      const localPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
      const domainPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

      return (
        localPattern.test(local) &&
        domainPattern.test(domain) &&
        /\.[a-zA-Z]{2,}$/.test(domain)
      );
    }

    normalizePhone(phone) {
      return String(phone || '').replace(/\D/g, '');
    }

    isValidPhone(phone) {
      return this.normalizePhone(phone).length === 10;
    }

    isValidState(state) {
      return /^[A-Z]{2}$/.test(state);
    }

    getPersonLabel(index) {
      return index === 0 ? 'Account holder' : `Member ${index + 1}`;
    }

    getPersonalDetailsErrors() {
      const details = this.collectPersonalDetails();
      const errors = [];

      details.forEach((detail, index) => {
        const label = this.getPersonLabel(index);

        if (!detail.first_name) {
          errors.push({ index, field: 'first_name', message: `${label}: First name is required` });
        }

        if (!detail.last_name) {
          errors.push({ index, field: 'last_name', message: `${label}: Last name is required` });
        }

        if (!detail.birthday) {
          errors.push({ index, field: 'birthday', message: `${label}: Birthday is required` });
        } else if (!this.isValidBirthday(detail.birthday)) {
          errors.push({ index, field: 'birthday', message: `${label}: Birthday must be a valid date (M/D/YYYY)` });
        }

        if (index === 0) {
          if (!detail.email) {
            errors.push({ index, field: 'email', message: `${label}: Email is required` });
          } else if (!this.isValidEmail(detail.email)) {
            errors.push({ index, field: 'email', message: `${label}: Email is invalid` });
          }
        } else if (detail.email && !this.isValidEmail(detail.email)) {
          errors.push({ index, field: 'email', message: `${label}: Email is invalid` });
        }

        if (index === 0) {
          if (!detail.phone) {
            errors.push({ index, field: 'phone', message: `${label}: Phone is required` });
          } else if (!this.isValidPhone(detail.phone)) {
            errors.push({ index, field: 'phone', message: `${label}: Phone must be 10 digits` });
          }
        } else if (detail.phone && !this.isValidPhone(detail.phone)) {
          errors.push({ index, field: 'phone', message: `${label}: Phone must be 10 digits` });
        }

        const allowOwnLoginError = this.getAllowOwnLoginError(detail, index);
        if (allowOwnLoginError) {
          errors.push(allowOwnLoginError);
        }

        if (!detail.state) {
          errors.push({ index, field: 'state', message: `${label}: State is required` });
        } else if (!this.isValidState(detail.state)) {
          errors.push({ index, field: 'state', message: `${label}: State must be a valid 2-letter code` });
        }
      });

      return errors;
    }

    getPersonFieldId(index, field) {
      const sectionId = this.getPersonalDetailsSectionId();
      const fieldIds = {
        first_name: `first-name-${sectionId}-${index}`,
        last_name: `last-name-${sectionId}-${index}`,
        birthday: `birthday-${sectionId}-${index}`,
        email: `email-${sectionId}-${index}`,
        phone: `phone-${sectionId}-${index}`,
        allow_own_login: `allow-own-login-${sectionId}-${index}`
      };

      return fieldIds[field] || '';
    }

    getAllowOwnLoginError(detail, index) {
      if (!detail.allow_own_login) return null;

      const label = this.getPersonLabel(index);
      const hasValidEmail = Boolean(detail.email && this.isValidEmail(detail.email));
      const hasValidPhone = this.isValidPhone(detail.phone);

      if (hasValidEmail && hasValidPhone) return null;

      return {
        index,
        field: hasValidEmail ? 'phone' : 'email',
        message: `${label}: A valid email address and valid phone number are required to allow login with own email`
      };
    }

    isCheckboxChecked(id) {
      return Boolean(this.querySelector(`#${id}`)?.checked);
    }

    collectPersonOptions(sectionId, index) {
      const skipSequencing = this.isCheckboxChecked(`skip-sequencing-${sectionId}-${index}`);

      if (index === 0) {
        return {
          allow_own_login: true,
          skip_sequencing: skipSequencing
        };
      }

      return {
        allow_own_login: this.isCheckboxChecked(`allow-own-login-${sectionId}-${index}`),
        skip_sequencing: skipSequencing
      };
    }

    focusPersonField(index, field) {
      const fieldId = this.getPersonFieldId(index, field);
      if (!fieldId) return;

      const input = this.querySelector(`#${fieldId}`);
      if (input) {
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    goToPersonalDetailsSlide(index, field) {
      const showSlide = () => {
        if (this.swiperInstance) {
          this.swiperInstance.slideTo(index);
        }

        setTimeout(() => this.focusPersonField(index, field), this.swiperInstance ? 350 : 0);
      };

      if (this.swiperInstance) {
        showSlide();
        return;
      }

      const swiperContainer = this.querySelector('[data-swiper-slider]');
      if (swiperContainer?.swiper) {
        this.swiperInstance = swiperContainer.swiper;
        showSlide();
        return;
      }

      setTimeout(showSlide, 300);
    }

    validatePersonalDetails() {
      const errors = this.getPersonalDetailsErrors();

      if (errors.length) {
        showToast(errors.map((error) => error.message).join('. '), {
          type: 'error',
          duration: Math.max(4000, errors.length * 2500)
        });
        return errors[0];
      }

      return null;
    }

    formatPersonSummary(detail, index) {
      const label = index === 0 ? 'Account holder' : `Member ${index + 1}`;
      const contactParts = [detail.email, detail.phone].filter(Boolean);
      const contact = contactParts.length ? `, ${contactParts.join(', ')}` : '';
      return `${label}: ${detail.first_name} ${detail.last_name}, ${detail.birthday}, ${detail.state}${contact}`;
    }

    updatePeopleSummary() {
      const container = this.querySelector('[id^="enrollment-people-summary-"]');
      if (!container) return;

      const details = this.collectPersonalDetails();
      container.innerHTML = details
        .map((detail, index) => {
          const summary = this.formatPersonSummary(detail, index);
          return `<p class="enrollment-people-summary__line">${this.escapeHtml(summary)}</p>`;
        })
        .join('');
    }

    buildPersonFieldsHtml(sectionId, index) {
      const isAccountHolder = index === 0;
      const namePrefix = `personal_details[${index}]`;
      const requiredMark = ' <span aria-hidden="true">*</span>';
      const loginNote = isAccountHolder ? '' : ' (required for login in services)';
      const useAccountProfile = isAccountHolder && this.isLoggedIn;
      const useAccountProfileNames = useAccountProfile && this.customerFirstName && this.customerLastName;
      const holderCheckboxAttrs = isAccountHolder ? 'checked disabled' : '';
      const allowOwnLoginCheckboxAttrs = holderCheckboxAttrs;

      const nameFieldsHtml = useAccountProfileNames
        ? `
          <div class="enrollment-form__field">
            <label>First name</label>
            <p class="enrollment-form__field-value">${this.escapeHtml(this.customerFirstName)}</p>
          </div>
          <div class="enrollment-form__field">
            <label>Last name</label>
            <p class="enrollment-form__field-value">${this.escapeHtml(this.customerLastName)}</p>
          </div>
        `
        : `
          <div class="enrollment-form__field">
            <label for="first-name-${sectionId}-${index}">First name <span aria-hidden="true">*</span></label>
            <input
              type="text"
              id="first-name-${sectionId}-${index}"
              name="${namePrefix}[first_name]"
              required
              autocomplete="given-name"
              class="field__input"
            >
          </div>
          <div class="enrollment-form__field">
            <label for="last-name-${sectionId}-${index}">Last name <span aria-hidden="true">*</span></label>
            <input
              type="text"
              id="last-name-${sectionId}-${index}"
              name="${namePrefix}[last_name]"
              required
              autocomplete="family-name"
              class="field__input"
            >
          </div>
        `;

      const emailFieldHtml = useAccountProfile
        ? `
          <div class="enrollment-form__field">
            <label>Email</label>
            <p class="enrollment-form__field-value">${this.escapeHtml(this.customerEmail)}</p>
          </div>
        `
        : `
          <div class="enrollment-form__field">
            <label for="email-${sectionId}-${index}">Email${isAccountHolder ? requiredMark : ''}</label>
            <input
              type="email"
              id="email-${sectionId}-${index}"
              name="${namePrefix}[email]"
              ${isAccountHolder ? 'required' : ''}
              autocomplete="email"
              class="field__input"
            >
          </div>
        `;

      return `
          ${nameFieldsHtml}
          <div class="enrollment-form__field">
            <label for="birthday-${sectionId}-${index}">Birthday (M/D/YYYY) <span aria-hidden="true">*</span></label>
            <input
              type="text"
              id="birthday-${sectionId}-${index}"
              name="${namePrefix}[birthday]"
              placeholder="M/D/YYYY"
              inputmode="numeric"
              autocomplete="bday"
              required
              class="field__input"
            >
          </div>
          ${emailFieldHtml}
          <div class="enrollment-form__field">
            <label for="phone-${sectionId}-${index}">Phone${loginNote}${isAccountHolder ? requiredMark : ''}</label>
            <input
              type="text"
              id="phone-${sectionId}-${index}"
              name="${namePrefix}[phone]"
              placeholder="(555) 555-5555"
              inputmode="numeric"
              ${isAccountHolder ? 'required' : ''}
              class="field__input"
            >
          </div>
          <div class="enrollment-form__field enrollment-form__field--checkbox">
            <label for="allow-own-login-${sectionId}-${index}">
              <input
                type="checkbox"
                id="allow-own-login-${sectionId}-${index}"
                name="${namePrefix}[allow_own_login]"
                value="1"
                ${allowOwnLoginCheckboxAttrs}
              >
              <span>Allow this user login with it's own email (requires valid email and phone number)</span>
            </label>
          </div>
          <div class="enrollment-form__field enrollment-form__field--checkbox">
            <label for="skip-sequencing-${sectionId}-${index}">
              <input
                type="checkbox"
                id="skip-sequencing-${sectionId}-${index}"
                name="${namePrefix}[skip_sequencing]"
                value="1"
              >
              <span>I don't want DNA sequencing for this user</span>
            </label>
          </div>
        `;
    }

    initializePersonalDetails() {
      const wrapper = this.querySelector('[id^="personal-details-wrapper"]');
      if (!wrapper) return;

      wrapper.innerHTML = '';

      const sectionId = wrapper.id.split('-').pop();

      for (let i = 0; i < this.membersCount; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide enrollment-personal-details__slide';
        slide.setAttribute('data-person-index', i);

        const slideTitle = i === 0
          ? 'Account holder'
          : `Member ${i + 1}`;
        const slideDescription = i === 0
          ? '<p class="enrollment-personal-details__slide-description">Responsible for billing</p>'
          : '';

        slide.innerHTML = `
          <h3 class="enrollment-personal-details__slide-title">${slideTitle}</h3>
          ${slideDescription}
          ${this.buildPersonFieldsHtml(sectionId, i)}
        `;

        wrapper.appendChild(slide);
      }

      this.initializeSwiper();
      this.bindPersonFieldEvents(sectionId);
    }

    bindPersonFieldEvents(sectionId) {
      for (let i = 1; i < this.membersCount; i++) {
        const checkbox = this.querySelector(`#allow-own-login-${sectionId}-${i}`);
        const phoneInput = this.querySelector(`#phone-${sectionId}-${i}`);
        const emailInput = this.querySelector(`#email-${sectionId}-${i}`);
        if (!checkbox) continue;

        checkbox.addEventListener('change', () => {
          if (!checkbox.checked) return;

          const error = this.getAllowOwnLoginError({
            allow_own_login: true,
            email: emailInput?.value?.trim() || '',
            phone: phoneInput?.value?.trim() || ''
          }, i);

          if (!error) return;

          checkbox.checked = false;
          showToast(error.message, {
            type: 'error',
            duration: 5000
          });
          this.focusPersonField(i, error.field);
        });
      }
    }

    initializeSwiper(resetToFirstSlide = true) {
      setTimeout(() => {
        const swiperElement = this.querySelector('swiper-slider');
        if (swiperElement) {
          const swiperContainer = swiperElement.querySelector('[data-swiper-slider]');

          if (swiperContainer && swiperContainer.swiper) {
            this.swiperInstance = swiperContainer.swiper;
            this.swiperInstance.update();
            if (resetToFirstSlide) {
              this.swiperInstance.slideTo(0);
            }
          } else {
            setTimeout(() => {
              if (swiperContainer && swiperContainer.swiper) {
                this.swiperInstance = swiperContainer.swiper;
                this.swiperInstance.update();
                if (resetToFirstSlide) {
                  this.swiperInstance.slideTo(0);
                }
              }
            }, 300);
          }
        }
      }, 100);
    }

    buildSelfEnrollPayload() {
      return {
        users: this.collectPersonalDetails().map((detail) => ({
          firstName: detail.first_name,
          lastName: detail.last_name,
          email: detail.email || null,
          phone: detail.phone ? this.normalizePhone(detail.phone) : null,
          birthday: detail.birthday,
          state: detail.state,
          allowOwnLogin: detail.allow_own_login,
          skipSequencing: detail.skip_sequencing
        }))
      };
    }

    getRequiredSequencingCount() {
      const skipCount = this.collectPersonalDetails().filter((detail) => detail.skip_sequencing).length;
      return Math.max(0, this.membersCount - skipCount);
    }

    allMembersSkipSequencing() {
      return this.collectPersonalDetails().every((detail) => detail.skip_sequencing);
    }

    cartHasPlan(cart) {
      if (!cart?.items?.length) return false;
      return cart.items.some((item) => this.isPlanCartItem(item));
    }

    isCartEmpty(cart) {
      return !cart?.items?.length;
    }

    getEmptyCartErrorMessage() {
      return 'We require at least one item in the cart to proceed. If no sequencing is required, select at least one plan.';
    }

    buildEmptyCartMarkup() {
      return `
        <div class="enrollment-cart-summary__empty-state enrollment-form__question" role="alert">
          <p>${this.escapeHtml(this.getEmptyCartErrorMessage())}</p>
          <p class="enrollment-cart-summary__empty-context">This applies when enrolling after a 30× clinical-grade whole genome sequencing upload.</p>
          <p>
            <a href="${ENROLLMENT_SERVICES_URL}">Return to the service selection page</a>
          </p>
        </div>
      `;
    }

    getSequencingCountError(cart) {
      if (this.isCartEmpty(cart)) return null;

      const hasPlan = this.cartHasPlan(cart);
      const seqCount = this.countSequencingServicesInCart(cart);
      const required = this.getRequiredSequencingCount();

      if (!hasPlan && seqCount === 0) {
        return 'Your cart must include at least one plan or DNA sequencing service.';
      }

      if (seqCount === 0) {
        if (!this.allMembersSkipSequencing()) {
          return 'When your cart has no DNA sequencing services, all members must opt out of DNA sequencing.';
        }
        return null;
      }

      if (seqCount !== required) {
        const cartLabel = seqCount === 1 ? '1 DNA sequencing service' : `${seqCount} DNA sequencing services`;
        const requiredLabel = required === 1 ? '1 DNA sequencing service is' : `${required} DNA sequencing services are`;
        return `Your cart has ${cartLabel}, but ${requiredLabel} required based on members who need DNA sequencing.`;
      }

      return null;
    }

    isSequencingCartItem(item) {
      const name = this.getCartItemName(item).toLowerCase();
      const description = String(item.product_description || '').toLowerCase();
      const handle = String(item.handle || '').toLowerCase();
      const url = String(item.url || '').toLowerCase();
      const productType = String(item.product_type || '').toLowerCase();

      return (
        name.includes('sequencing') ||
        description.includes('sequencing') ||
        handle.includes('sequencing') ||
        url.includes('sequencing') ||
        productType.includes('sequencing')
      );
    }

    countSequencingServicesInCart(cart) {
      if (!cart?.items?.length) return 0;

      return cart.items.reduce((total, item) => {
        if (this.isSequencingCartItem(item)) {
          return total + (item.quantity || 0);
        }
        return total;
      }, 0);
    }

    getCartItemName(item) {
      const title = String(item.product_title || '');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        return `${title} — ${item.variant_title}`;
      }
      return title;
    }

    isPlanCartItem(item) {
      return this.getCartItemName(item).toLowerCase().includes('plan');
    }

    getPlanLimitError(cart) {
      if (this.isCartEmpty(cart)) return null;

      const planItems = cart.items.filter((item) => this.isPlanCartItem(item));
      if (!planItems.length) return null;

      const planLineCount = planItems.length;
      const planWithMultipleUnits = planItems.some((item) => (item.quantity || 0) > 1);

      if (planLineCount > 1) {
        return 'Only one plan per account is allowed. Please remove extra plan items from your cart.';
      }

      if (planWithMultipleUnits) {
        return 'Only one plan per account is allowed. Plan quantity must be 1.';
      }

      return null;
    }

    updateSubmitButtonForCartValidation(cart) {
      const submitBtn = this.querySelector('.enrollment-form__submit-btn');
      if (!submitBtn || this.currentStep !== 3) return;

      if (this.isCartEmpty(cart)) {
        submitBtn.disabled = true;
        return;
      }

      const planError = this.getPlanLimitError(cart);
      const sequencingError = this.getSequencingCountError(cart);
      submitBtn.disabled = Boolean(planError || sequencingError);
    }

    async validatePlanLimitsInCart() {
      try {
        const cart = await this.fetchCart();
        return this.getPlanLimitError(cart);
      } catch (error) {
        return 'Unable to verify plan items in your cart. Please refresh the page.';
      }
    }

    async validateSequencingServicesInCart() {
      try {
        const cart = await this.fetchCart();
        if (this.isCartEmpty(cart)) {
          return this.getEmptyCartErrorMessage();
        }
        return this.getSequencingCountError(cart);
      } catch (error) {
        return 'Unable to verify DNA sequencing services in your cart. Please refresh the page.';
      }
    }

    showSequencingCountToast(cart) {
      if (this.isCartEmpty(cart)) {
        showToast(this.getEmptyCartErrorMessage(), {
          type: 'error',
          duration: 6000
        });
        return;
      }

      const error = this.getSequencingCountError(cart);
      if (!error) return;

      showToast(error, {
        type: 'error',
        duration: 6000
      });
    }

    fetchWithTimeout(url, options, timeoutMs) {
      return new Promise((resolve, reject) => {
        let didTimeOut = false;

        const timer = setTimeout(() => {
          didTimeOut = true;
          reject(new Error('Request timed out'));
        }, timeoutMs);

        fetch(url, options)
          .then((response) => {
            if (didTimeOut) return;
            clearTimeout(timer);
            resolve(response);
          })
          .catch((error) => {
            if (didTimeOut) return;
            clearTimeout(timer);
            reject(error);
          });
      });
    }

    extractSelfEnrollErrorMessage(data, text) {
      if (typeof data === 'string') {
        return this.sanitizeErrorMessage(data);
      }

      if (data && typeof data === 'object') {
        if (typeof data.error === 'string') {
          return data.error;
        }

        if (typeof data.message === 'string') {
          return data.message;
        }

        if (typeof data.errorMessage === 'string') {
          return data.errorMessage;
        }

        const userErrors = Array.isArray(data.userErrors)
          ? data.userErrors
          : (data.error && Array.isArray(data.error.userErrors) ? data.error.userErrors : null);

        if (userErrors && userErrors.length) {
          return userErrors
            .map((entry) => entry && entry.message)
            .filter(Boolean)
            .join('. ');
        }

        if (Array.isArray(data.errors) && data.errors.length) {
          return data.errors
            .map((entry) => (typeof entry === 'string' ? entry : entry && entry.message))
            .filter(Boolean)
            .join('. ');
        }
      }

      return this.sanitizeErrorMessage(text);
    }

    sanitizeErrorMessage(text) {
      if (!text || typeof text !== 'string') {
        return '';
      }

      const trimmed = text.trim();
      if (!trimmed) {
        return '';
      }

      const htmlTagPattern = new RegExp('<' + 'html[\\s>]', 'i');
      const scriptTagPattern = new RegExp('<' + 'script[\\s>]', 'i');

      if (
        trimmed.startsWith('<') ||
        htmlTagPattern.test(trimmed) ||
        scriptTagPattern.test(trimmed) ||
        trimmed.length > 300
      ) {
        return '';
      }

      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          return this.extractSelfEnrollErrorMessage(JSON.parse(trimmed), '');
        } catch (error) {
          return '';
        }
      }

      return trimmed;
    }

    async parseProxyResponse(response) {
      try {
        const text = await response.text();
        if (!text) {
          return { ok: false, data: null, message: '' };
        }

        try {
          const data = JSON.parse(text);

          if (typeof data === 'string') {
            return { ok: false, data: null, message: data };
          }

          if (data && data.ok === true) {
            return { ok: true, data, message: '' };
          }

          const message = this.extractSelfEnrollErrorMessage(data, text);
          return { ok: false, data, message };
        } catch (error) {
          return { ok: false, data: null, message: this.extractSelfEnrollErrorMessage(null, text) };
        }
      } catch (error) {
        return { ok: false, data: null, message: '' };
      }
    }

    parseSelfEnrollFieldError(message, data) {
      if (data && Array.isArray(data.userErrors) && data.userErrors.length) {
        const entry = data.userErrors[0];
        const apiField = Array.isArray(entry.field) ? entry.field[0] : entry.field;
        const fieldMap = {
          firstName: 'first_name',
          lastName: 'last_name',
          email: 'email',
          phone: 'phone',
          birthday: 'birthday',
          state: 'state'
        };
        const index = Number.isInteger(data.userIndex) ? data.userIndex : 0;

        if (apiField && fieldMap[apiField]) {
          return { index, field: fieldMap[apiField] };
        }
      }

      if (!message) return null;

      if (/users\[0\] must have email, firstName, and lastName/i.test(message)) {
        if (this.isLoggedIn) {
          if (!this.customerFirstName) return { index: 0, field: 'first_name' };
          if (!this.customerLastName) return { index: 0, field: 'last_name' };
          return { index: 0, field: 'email' };
        }

        return { index: 0, field: 'first_name' };
      }

      const birthdayMatch = message.match(/users\[(\d+)\]\.birthday is invalid/i);
      if (birthdayMatch) {
        return { index: parseInt(birthdayMatch[1], 10), field: 'birthday' };
      }

      if (/phone is invalid/i.test(message)) {
        const phoneMatch = message.match(/users\[(\d+)\]/i);
        return { index: phoneMatch ? parseInt(phoneMatch[1], 10) : 0, field: 'phone' };
      }

      return null;
    }

    isSelfEnrollStateError(message) {
      return /users\[\d+\]\.state must be a 2-letter state code/i.test(message || '');
    }

    showSelfEnrollError(message, data) {
      showToast(message || 'Unable to complete enrollment. Please try again later.', {
        type: 'error',
        duration: 6000
      });

      if (this.isSelfEnrollStateError(message)) {
        this.showStateRequired();
        return;
      }

      const fieldError = this.parseSelfEnrollFieldError(message, data);
      if (fieldError) {
        this.pendingPersonalDetailsError = fieldError;
        this.goToStep(1);
      }
    }

    async handleSubmit() {
      if (!this.hasRequiredState) {
        this.showStateRequired();
        return;
      }

      if (!this.hasCartItems) {
        this.showCartRequired();
        return;
      }

      let cart;
      try {
        cart = await this.fetchCart();
      } catch (error) {
        showToast('Unable to load your cart. Please refresh the page.', {
          type: 'error',
          duration: 6000
        });
        return;
      }

      if (this.isCartEmpty(cart)) {
        showToast(this.getEmptyCartErrorMessage(), {
          type: 'error',
          duration: 6000
        });
        await this.goToStep(3);
        return;
      }

      const firstError = this.validatePersonalDetails();
      if (firstError) {
        this.pendingPersonalDetailsError = firstError;
        this.goToStep(1);
        return;
      }

      const sequencingError = this.getSequencingCountError(cart);
      if (sequencingError) {
        showToast(sequencingError, {
          type: 'error',
          duration: 6000
        });
        return;
      }

      const planError = this.getPlanLimitError(cart);
      if (planError) {
        showToast(planError, {
          type: 'error',
          duration: 6000
        });
        return;
      }

      const submitBtn = this.querySelector('.enrollment-form__submit-btn');
      const payload = this.buildSelfEnrollPayload();
      const proxyUrl = `${ENROLLMENT_APP_PROXY_PATH}?topic=self-enroll`;

      if (submitBtn) {
        submitBtn.disabled = true;
      }

      try {
        const response = await this.fetchWithTimeout(
          proxyUrl,
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          },
          ENROLLMENT_REQUEST_TIMEOUT_MS
        );

        const result = await this.parseProxyResponse(response);

        if (!response.ok || !result.ok) {
          this.showSelfEnrollError(
            result.message || 'Unable to complete enrollment. Please try again later.',
            result.data
          );
          return;
        }

        window.location.href = '/checkout';
      } catch (error) {
        console.error(error);
        showToast('Network issue or timeout. Please try again.', {
          type: 'error',
          duration: 6000
        });
      } finally {
        if (submitBtn) {
          if (this.currentStep === 3) {
            this.fetchCart().then((cart) => {
              this.updateSubmitButtonForCartValidation(cart);
            });
          } else {
            submitBtn.disabled = false;
          }
        }
      }
    }

    formatMoney(cents) {
      const amount = Math.round(cents);
      const moneyFormat = this.dataset.moneyFormat;
      if (window.Shopify && window.Shopify.formatMoney && moneyFormat) {
        return Shopify.formatMoney(amount, (typeof DT_THEME !== 'undefined' && DT_THEME.moneyFormat) || moneyFormat);
      }
      return (amount / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD' });
    }

    getCartSummaryContainer() {
      return this.querySelector('[id^="enrollment-cart-summary"]');
    }

    async fetchCart() {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Failed to load cart');
      return response.json();
    }

    async changeCartLine(line, quantity) {
      if (typeof routes === 'undefined' || !routes.cart_change_url) {
        throw new Error('Cart routes unavailable');
      }

      const config = typeof fetchConfig === 'function'
        ? fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

      const response = await fetch(routes.cart_change_url, {
        ...config,
        body: JSON.stringify({ line, quantity })
      });

      if (!response.ok) throw new Error('Failed to update cart');
      return response.json();
    }

    buildCartSummaryMarkup(cart) {
      if (this.isCartEmpty(cart)) {
        return this.buildEmptyCartMarkup();
      }

      const itemsHtml = cart.items.map((item, index) => {
        const line = index + 1;
        const linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        return `
          <li class="enrollment-cart-summary__item" data-cart-line="${line}">
            <p class="enrollment-cart-summary__item-title">${this.escapeHtml(item.product_title)}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${this.escapeHtml(item.variant_title)}` : ''}</p>
            <div class="enrollment-cart-summary__qty">
              <label class="visually-hidden" for="cart-qty-${line}">Quantity for ${this.escapeHtml(item.product_title)}</label>
              <input
                type="number"
                id="cart-qty-${line}"
                class="enrollment-cart-summary__qty-input"
                data-line="${line}"
                min="0"
                step="1"
                value="${item.quantity}"
              >
            </div>
            <span class="enrollment-cart-summary__item-price">${this.formatMoney(linePrice)}</span>
          </li>
        `;
      }).join('');

      const planError = this.getPlanLimitError(cart);
      const sequencingError = this.getSequencingCountError(cart);
      const planErrorHtml = planError
        ? `<p class="enrollment-cart-summary__error enrollment-cart-summary__plan-error" role="alert">${this.escapeHtml(planError)}</p>`
        : '';
      const sequencingErrorHtml = sequencingError
        ? `<p class="enrollment-cart-summary__error enrollment-cart-summary__sequencing-error" role="alert">${this.escapeHtml(sequencingError)}</p>`
        : '';

      return `
        <ul class="enrollment-cart-summary__list">${itemsHtml}</ul>
        <div class="enrollment-cart-summary__total">
          <span>Total</span>
          <span class="enrollment-cart-summary__total-value">${this.formatMoney(cart.total_price)}</span>
        </div>
        ${planErrorHtml}
        ${sequencingErrorHtml}
      `;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    bindCartQuantityInputs(container) {
      container.querySelectorAll('.enrollment-cart-summary__qty-input').forEach((input) => {
        input.addEventListener('change', () => this.onCartQuantityChange(input));
      });
    }

    onCartQuantityChange(input) {
      clearTimeout(this.cartUpdateTimer);
      this.cartUpdateTimer = setTimeout(() => this.updateCartQuantity(input), 400);
    }

    async updateCartQuantity(input) {
      const line = Number.parseInt(input.dataset.line, 10);
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      const container = this.getCartSummaryContainer();
      if (!container || !Number.isInteger(line)) return;

      input.disabled = true;
      container.classList.add('enrollment-cart-summary--loading');

      try {
        const cart = await this.changeCartLine(line, quantity);
        container.innerHTML = this.buildCartSummaryMarkup(cart);
        this.bindCartQuantityInputs(container);
        this.updateSubmitButtonForCartValidation(cart);
        this.showSequencingCountToast(cart);
      } catch (error) {
        console.error(error);
        await this.renderCartSummary();
        const errorNote = document.createElement('p');
        errorNote.className = 'enrollment-cart-summary__error';
        errorNote.textContent = 'Could not update quantity. Please try again.';
        container.appendChild(errorNote);
      } finally {
        input.disabled = false;
        container.classList.remove('enrollment-cart-summary--loading');
      }
    }

    async renderCartSummary() {
      const container = this.getCartSummaryContainer();
      if (!container) return;

      container.innerHTML = '<p class="enrollment-cart-summary__loading">Loading cart…</p>';

      try {
        const cart = await this.fetchCart();
        container.innerHTML = this.buildCartSummaryMarkup(cart);
        this.bindCartQuantityInputs(container);
        this.updateSubmitButtonForCartValidation(cart);
        this.showSequencingCountToast(cart);
      } catch (error) {
        console.error(error);
        container.innerHTML = '<p class="enrollment-cart-summary__empty">Unable to load cart. Please refresh the page.</p>';
      }
    }
  }

  customElements.define('enrollment-form', EnrollmentForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready( function() {   

$('.gallery-1').isotope({
  itemSelector: '.grid-item',
});

// filter items on button click
$('.filter-button-group').on( 'click', '.tablinks', function() {
  var filterValue = $(this).attr('data-filter');
  console.log(filterValue);
  $('.gallery-1').isotope({ filter: filterValue });
  $('.filter-button-group div').removeClass('active');
  $(this).addClass('active');
});
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
(function($) {
    swipr = () => {
        if($('.swiper-container').length) {          
            $(".swiper-container").each(function(i) {
                var slides_per_view = $(this).attr('slidesperview');
                var pause_on_hover = $(this).attr('pauseonhover') ? true : false;
                var slide_delay = $(this).attr('slidedelay');
				var id = $(this).attr('slider-id');
                let swiper = new Swiper($(this)[0], {
                    loop: false,
                    slidesPerView: slides_per_view,
                    spaceBetween: 20,
                    autoplay: {
                        delay: slide_delay,
                    },
                  pagination: {
                    el: '#pagination-' + id + '-btn',
                    clickable: true
                  },
                  navigation: {
                    nextEl: '#next-' + id + '-btn',
                    prevEl: '#prev-' + id + '-btn'
                  },
              // Responsive breakpoints
                breakpoints: {
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 40
                  }
                }
                });
            });
        }
    };
     
    document.addEventListener("DOMContentLoaded", () => { swipr() }); 
})(jQuery);


  } catch(e) { console.error(e); }
})();
})();
